
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.004 20.566c1.187 0 2.08-.296 2.678-.89.597-.594.896-1.473.896-2.637V3.527c0-1.164-.299-2.043-.896-2.636C19.084.297 18.192 0 17.004 0H3.574C2.394 0 1.504.295.902.885.301 1.475 0 2.355 0 3.527V17.04c0 1.172.3 2.053.902 2.643.602.59 1.493.884 2.672.884h13.43zm-.082-2.003H3.656c-.523 0-.927-.141-1.213-.422-.285-.282-.427-.7-.427-1.254V3.68c0-.555.142-.973.427-1.254.286-.281.69-.422 1.213-.422h13.266c.523 0 .93.14 1.219.422.289.281.433.699.433 1.254v13.207c0 .554-.144.972-.433 1.254-.29.28-.696.422-1.22.422zm-7.828-3.036c.398 0 .715-.183.949-.55l5.039-7.864c.063-.117.123-.238.182-.363a.877.877 0 00.088-.375c0-.258-.1-.467-.3-.627-.198-.16-.42-.24-.661-.24-.329 0-.606.18-.832.539l-4.5 7.195-2.11-2.719a1.235 1.235 0 00-.404-.345.993.993 0 00-.44-.1.878.878 0 00-.662.276.923.923 0 00-.263.662c0 .242.093.484.28.726l2.65 3.235c.148.195.3.335.456.421.157.086.332.13.528.13z","fill":"#fff"}})])
          )
        }
      }
    